<mat-form-field class="bms-theme full-width full-height overflow-hidden no-subscript flex-center">
  <vdw-object-selection
    class="full-width full-height"
    [class.hide-icon]="!params.column.isCellEditable(params.node)"
    [formControl]="formControl"
    [objectName]="objectName"
    [canShowBMSTheme]="true"
    [withDialogObjectSelection]="true"
    [canShowMultiSelectPlaceHolder]="multiple"
  ></vdw-object-selection>
</mat-form-field>
